import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 bg-cream" data-id="element-184">
      <div className="container mx-auto px-6 max-w-4xl" data-id="element-185">
        <FadeIn data-id="element-186">
          <div className="bg-gradient-to-br from-gold-light/40 to-sage-light/40 p-8 md:p-12 rounded-3xl border border-gold/20 shadow-lg relative" data-id="element-187">
            <div className="absolute -top-6 -right-6 bg-white p-4 rounded-full shadow-md text-gold" data-id="element-188">
              <Sparkles className="w-8 h-8" data-id="element-189" />
            </div>

            <h2 className="text-2xl md:text-3xl font-bold text-forest mb-6" data-id="element-190">
              Lo que cambia en 7 días:
            </h2>

            <p className="text-xl md:text-2xl text-forest/80 leading-relaxed font-medium italic" data-id="element-191">
              "Al estabilizar tu glucosa desde el desayuno, la inflamación
              abdominal visible empieza a ceder y la niebla mental de la tarde
              desaparece, permitiéndote llegar al final del día con energía
              real, no dependiente de la cafeína."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}